import React from "react";

export default function LoadAnimation() {
    return (<div className="loader"><div>Loading</div></div>);
}